import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IEtaState } from './types';

const initialState: IEtaState = {
  allTaskEta: {},
};

const slice = createSlice({
  name: 'eta',
  initialState,
  reducers: {
    getAllTaskEta(state, action: PayloadAction<{ projectId: string }>) {
      state.allTaskEta.status = RequestStatus.RUNNING;
    },
    getAllTaskEtaSuccess(state, action: PayloadAction<IEtaState>) {
      state.allTaskEta.status = RequestStatus.SUCCESS;
      state.allTaskEta.data = action.payload;
    },
    getAllTaskEtaFailed(state, action: PayloadAction<IRequestFailed>) {
      state.allTaskEta.status = RequestStatus.ERROR;
      state.allTaskEta.error = action.payload;
    },
  },
});
export default slice.reducer;

export const { getAllTaskEta, getAllTaskEtaFailed, getAllTaskEtaSuccess } = slice.actions;
